/**
 * YouTube API
 *
 * @namespace APP
 * @name APP.Youtube
 */
APP.Youtube = (/** @lends APP.Youtube */function () {
	'use strict';

	/* eslint no-underscore-dangle: 0 */
	/* eslint no-unused-vars: 0 */
	var exports,
		indexPlayerStarted = false,
		indexPlayer,
		playStorage = {};

	/**
	 * Initialize Youtube API
	 *
	 * @inner
	 * @public
	 * @memberof APP.Youtube
	 * @returns {void}
	 */
	function init() {
		initBindings();
		setTimeout(function () {
			injectYoutubeAPI();
		}, 200);
	}

	function injectYoutubeAPI() {
		var tag = document.createElement('script'),
			firstScriptTag;

		tag.src = 'https://www.youtube.com/iframe_api';
		firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	function initBindings() {
		window.onYouTubeIframeAPIReady = function () {
			indexPlayer = new YT.Player('indexPlayer', {
				events: {
					onStateChange: function (e) {
						stateChangeHandler(e.data, 'indexPlayer');
					},
					onReady: function () {

						if (playStorage.indexPlayer) {
							indexPlayer.playVideo();
						}
					}
				}
			});
		};
	}

	function stateChangeHandler(state, playerId) {
		var title, url;

		if (playerId === 'indexPlayer') {

			if (indexPlayer) {
				title = indexPlayer.getVideoData().title;
				url = indexPlayer.getVideoUrl();
			}

			if (state === 1) {
				if (indexPlayerStarted === false) {
					APP.Analytics.trackEvent('Interaction', 'Video', title + ' (' + url + '): play');
					indexPlayerStarted = true;
				}
			} else if (state === 0) {
				APP.Analytics.trackEvent('Interaction', 'Video', title + ' (' + url + '): 100% played');
				indexPlayerStarted = false;
			}

		}
	}

	exports = {
		init: init,
		getPlayer: function () {
			return indexPlayer !== undefined ? indexPlayer : false;
		},
		playVideo: function (id) {
			if (indexPlayer && indexPlayer.playVideo) {
				indexPlayer.playVideo();
			} else {
				playStorage[id] = true;
			}
		}
	};

	/* test-code */
	/* eslint no-underscore-dangle: 0 */
	exports.__testonly__ = {};
	/* end-test-code */

	return exports;

}());
